import { createAsyncThunk } from "@reduxjs/toolkit";

import { fetchAuthToken } from "@/helpers/fetch-auth-token";
import {
  deletePin,
  getMarkerData,
  getMarkerDetailsData,
  handleEditMarker,
  handlePostMarker,
  likePin,
  reportPin,
  undoLikePin
} from "@/models";
import { AppState } from "@/redux/store/store";

export const postMarker = createAsyncThunk(
  "places/createMarkerThunk",
  async (
    params: Partial<{ projectId: string; placesId: string; body }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, body } = params;

    try {
      const response = await handlePostMarker(
        token,
        baseUrl,
        projectId,
        placesId,
        body,
        {}
      );
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateMarker = createAsyncThunk(
  "places/updateMarkerThunk",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: any;
      body;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, body, markerId } = params;

    try {
      const response = await handleEditMarker(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId,
        body,
        {}
      );
      return response?.data?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteMarker = createAsyncThunk(
  "places/deleteMarker",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: string;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, markerId } = params;
    try {
      const response = await deletePin(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const reportMarker = createAsyncThunk(
  "places/reportMarker",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: string;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, markerId } = params;

    try {
      const response = await reportPin(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const likeMarker = createAsyncThunk(
  "places/likeMarker",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: string;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, markerId } = params;
    try {
      const response = await likePin(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const undoLikeMarker = createAsyncThunk(
  "places/undoLikeMarker",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: string;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, markerId } = params;

    try {
      const response = await undoLikePin(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMarkerDetails = createAsyncThunk(
  "places/getMarkerDetails",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      markerId: string;
      config: object;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, markerId, config } = params;

    try {
      const response = await getMarkerData(
        token,
        baseUrl,
        projectId,
        placesId,
        markerId,
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getIndividualPinDetails = createAsyncThunk(
  "places/getIndividualPinDetails",
  async (
    params: Partial<{
      projectId: string;
      placesId: string;
      marker: string;
      config: object;
    }>,
    { rejectWithValue, getState }
  ) => {
    const { adapter } = getState() as AppState;
    const { token } = fetchAuthToken(getState());

    const { baseUrl } = adapter.adapter;
    const { projectId, placesId, marker, config } = params;

    try {
      const response = await getMarkerDetailsData(
        token,
        baseUrl,
        projectId,
        placesId,
        marker,
        params,
        config
      );

      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
